// extracted by mini-css-extract-plugin
export default {"iconWrapper":"ClippyTaskbarIcon_iconWrapper__AmC-g"};